import { type Duration, ms } from './ms';

export const random = (
  min: Duration,
  max: Duration,
  includingUpperBound = true
) => {
  let ms1 = ms(min);
  let ms2 = ms(max) + (includingUpperBound ? 1 : 0);
  if (ms1 < ms2) {
    const ms3 = ms1;
    ms1 = ms2;
    ms2 = ms3;
  }
  return Math.floor(Math.random() * (ms2 - ms1)) + ms1;
};
